/**
 * API segnalazioni tutela — stub con fallback locale.
 * Attivare REACT_APP_BACKEND_URL per persistenza server.
 */

import axios from "axios";

const API = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "");
const client = axios.create({
  baseURL: API ? `${API}/api` : "",
  withCredentials: true,
  timeout: 15000,
});

export function tutelaApiAvailable() {
  return Boolean(API);
}

export async function submitSegnalazioneTutela(payload) {
  if (!tutelaApiAvailable()) {
    return { ok: false, offline: true, reason: "backend_not_configured" };
  }
  try {
    const body = {
      comuneSlug: payload.comuneSlug,
      description: payload.description,
      photoData: payload.photoData,
      coords: payload.coords,
      createdAt: payload.createdAt,
    };
    const { data } = await client.post("/tutela/segnalazioni", body);
    return { ok: true, data };
  } catch (err) {
    const status = err?.response?.status;
    const detail = err?.response?.data?.detail;
    if (status === 422) {
      return { ok: false, blocked: true, message: detail || "Immagine non idonea per la sicurezza del territorio." };
    }
    if (status === 404 || status === 501) {
      return { ok: false, offline: true, reason: "endpoint_not_ready" };
    }
    throw err;
  }
}
